import {LiveImageDTO, LiveImage} from "./image";

export class FanBoxMessagesImageDTO extends LiveImageDTO {
  large: string;
}

export class FanBoxMessagesImage extends LiveImage {
  protected _large: string;

  get large(): string {
    return this.isSaved ? this._large : this.url;
  }

  constructor(data: FanBoxMessagesImageDTO) {
    super(data);
    this._large = data.large;
  }
}



// WEBPACK FOOTER //
// ./src/api/fanboxMessagesImage.ts